import { Component } from '@theme/component';

/**
 * Video Section
 *
 * Click-to-play video panel. Hosted Shopify videos render a native
 * <video> element; external videos (YouTube / Vimeo) get their iframe
 * injected on first play so no third-party assets load up-front.
 */
class VideoSection extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelector('[data-video-poster]')?.addEventListener('click', this.#play);
    this.querySelector('video')?.addEventListener('click', this.#togglePlayback);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.querySelector('[data-video-poster]')?.removeEventListener('click', this.#play);
    this.querySelector('video')?.removeEventListener('click', this.#togglePlayback);
  }

  /** The video has no native controls, so a tap on it pauses / resumes. */
  #togglePlayback = () => {
    const video = this.querySelector('video');
    if (!(video instanceof HTMLVideoElement)) return;
    if (video.paused) video.play();
    else video.pause();
  };

  #play = () => {
    const poster = this.querySelector('[data-video-poster]');
    const video = this.querySelector('video');
    const embed = this.querySelector('.video-section__embed');

    if (video instanceof HTMLVideoElement) {
      if (poster) poster.hidden = true;
      video.play();
      return;
    }

    if (embed instanceof HTMLElement && !embed.querySelector('iframe')) {
      const host = embed.dataset.videoHost;
      const id = embed.dataset.videoId;
      if (!host || !id) return;

      const src = host === 'youtube'
        ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&playsinline=1`
        : `https://player.vimeo.com/video/${id}?autoplay=1`;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = this.querySelector('[data-video-play]')?.getAttribute('aria-label') ?? '';
      embed.appendChild(iframe);
      if (poster) poster.hidden = true;
    }
  };
}

if (!customElements.get('video-section')) {
  customElements.define('video-section', VideoSection);
}
